export enum AttractionItemType {
    BEACHES = "beaches",
    RESTAURANTS = "restaurants",
    SIGHTSEEINGS = "sightseeings",
    EVENTS = "events",
    THINGS_TO_DO = "things to do",
}
export type AttractionPrice = 1 | 2 | 3 | 4 | null | undefined;
export type AttractionDuration = 1 | 2 | 12 | 24 | null | undefined;
export interface ThingToDoItem {
    id: string | number;
    title: string;
    description?: string;
    image: {
        url: string;
        alt?: string;
    };
    priceRange: AttractionPrice;
    link: string;
    duration: AttractionDuration;
    tags?: Array<string>;
}

export interface AttractionContactInfo {
    phone?: string;
    website?: string;
    address?: string;
}
